<template>
  <section class="">
    <print-store-menu></print-store-menu>
  </section>
</template>
<script>
import PrintStoreMenu from '@/features/printstore/MainMenu.vue'

export default {
  props: [],
  components: { PrintStoreMenu },
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
<style lang="scss" scoped></style>
